import { render, staticRenderFns } from "./text-count.vue?vue&type=template&id=1877f163&scoped=true"
import script from "./text-count.vue?vue&type=script&lang=js"
export * from "./text-count.vue?vue&type=script&lang=js"
import style0 from "./text-count.vue?vue&type=style&index=0&id=1877f163&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1877f163",
  null
  
)

export default component.exports